
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.5 1.667h7A2.333 2.333 0 0112.834 4v7a2.333 2.333 0 01-2.334 2.334h-7A2.333 2.333 0 011.167 11V4A2.333 2.333 0 013.5 1.667zm8.031 10.364c.274-.273.428-.644.428-1.03V4A1.458 1.458 0 0010.5 2.541h-7c-.805 0-1.458.653-1.458 1.458v7A1.458 1.458 0 003.5 12.46h7c.387 0 .758-.154 1.031-.428z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.997 9.6a.44.44 0 01-.287-.108L4.356 8.328a.493.493 0 01-.053-.661.438.438 0 01.627-.075l1.049.9L9 5.57a.44.44 0 01.466-.153c.17.048.298.196.328.38a.487.487 0 01-.19.471L6.305 9.473a.436.436 0 01-.308.127z","fill":"#fff"}})])
          )
        }
      }
    